/*
 * WW Sigma Motion — shared scroll-reveal driver.
 * Author: Tayler — 2026-06-29
 * IntersectionObserver reveals [data-reveal] once on enter; [data-reveal-group] staggers its
 * [data-reveal] descendants (data-reveal-step ms, default 70). Reduced-motion = reveal all
 * instantly. Binds once; re-inits per section in the theme editor (shopify:section:load).
 */
(function () {
  if (window.__wwSigmaMotion) return;
  window.__wwSigmaMotion = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el, delay) {
    if (delay) el.style.transitionDelay = delay + 'ms';
    el.classList.add('is-in');
  }

  var io = (typeof IntersectionObserver !== 'undefined') && new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      io.unobserve(el);
      if (el.hasAttribute('data-reveal-group')) {
        var step = parseInt(el.getAttribute('data-reveal-step') || '70', 10);
        var items = el.querySelectorAll('[data-reveal]');
        for (var i = 0; i < items.length; i++) show(items[i], i * step);
      } else {
        show(el, 0);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  function init(root) {
    root = root || document;
    if (reduce || !io) {
      root.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    root.querySelectorAll('[data-reveal-group]').forEach(function (g) { io.observe(g); });
    root.querySelectorAll('[data-reveal]').forEach(function (el) {
      if (!el.closest('[data-reveal-group]')) io.observe(el);
    });

    // ambient idle motion runs only while on screen (Rule 6 — pause off-viewport)
    var ambient = root.querySelectorAll('[data-ambient]');
    if (ambient.length && typeof IntersectionObserver !== 'undefined') {
      var aio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { e.target.classList.toggle('is-near', e.isIntersecting); });
      });
      ambient.forEach(function (el) { aio.observe(el); });
    }
  }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
